import { ApiClientAxios as Axios, GetLifeDetailV2Response, ProductNameType } from "@repo/api";
import { useTypedTranslation } from "../../hooks";
import { InfiniteData, UseInfiniteQueryResult } from "@repo/logic";
import { FC } from "react";
import * as Styled from "./TransactionsTab.styled";
import { TransactionsTabHowToPay } from "./TransactionsTabHowToPay";
import { PaymentsOverviewFilter, TransactionsTabPaymentsOverview } from "./TransactionsTabPaymentsOverview";
import { PremiumScheduleFilter, TransactionsTabPremiumSchedule } from "./TransactionsTabPremiumSchedule";
import { TransactionsTabTopCards } from "./TransactionsTabTopCards";

export type TransactionsTabProps = {
    helpBox?: React.ReactNode;
    contract?: GetLifeDetailV2Response;
    moneyInsQuery?: {
        query: UseInfiniteQueryResult<InfiniteData<Axios.FufiFinancialInfoResponse, unknown>, unknown>;
        flatData: Axios.FufiFinancialInfoMoneyIn[];
    };
    premiumsQuery?: {
        query: UseInfiniteQueryResult<InfiniteData<Axios.FufiFinancialInfoResponse, unknown>, unknown>;
        flatData: Axios.FufiFinancialInfoPremium[];
    };
    onPremiumFilterChange?: (filter: PremiumScheduleFilter) => void;
    premiumFilter?: PremiumScheduleFilter;
    onMoneyInsFilterChange?: (filter: PaymentsOverviewFilter) => void;
    moneyInsFilter?: PaymentsOverviewFilter;
    productName?: ProductNameType | null;
};

export const TransactionsTab: FC<TransactionsTabProps> = ({
    helpBox,
    contract,
    moneyInsQuery,
    premiumsQuery,
    onPremiumFilterChange,
    premiumFilter,
    onMoneyInsFilterChange,
    moneyInsFilter,
    productName,
}) => {
    const { t } = useTypedTranslation();
    const isUlSingle = productName === ProductNameType.NnFufiUlSingle;
    const isUlInitialUnits = productName === ProductNameType.NnFufiUl;

    return (
        <Styled.TransactionsTabContainer>
            {contract ? (
                <TransactionsTabTopCards
                    contribution={contract?.premiumClient}
                    paymentFrequency={contract?.paymentFrequency}
                    debt={contract?.debtClient}
                    paidToDate={contract?.paymentDetails.paidToDate}
                    hideDebt={isUlSingle}
                    contributionLabel={isUlSingle ? t("life.contractDetail.table.labels.shared.contributionSinglePremium") : undefined}
                />
            ) : (
                <TransactionsTabTopCards
                    // this shows skeletons
                    contribution={undefined}
                    paymentFrequency={undefined}
                    debt={undefined}
                    paidToDate={undefined}
                />
            )}

            <TransactionsTabPremiumSchedule
                premiumsQuery={premiumsQuery}
                onFilterChange={onPremiumFilterChange}
                filter={premiumFilter}
                hidePaymentDate={isUlInitialUnits || isUlSingle || contract?.productName === ProductNameType.NnOrangeBonus}
            />

            <TransactionsTabPaymentsOverview
                moneyInsQuery={moneyInsQuery}
                onFilterChange={onMoneyInsFilterChange}
                filter={moneyInsFilter}
            />

            <TransactionsTabHowToPay contract={contract} />

            {helpBox}
        </Styled.TransactionsTabContainer>
    );
};
